<template>
<div>
   <div class="container-fluid bottom mt-5">
  <div class="row mx-auto w-75">
    <div class="col">
         <h3 class="all mt-5"> Our Vision</h3>
         <p class="long">A wonderful serenity has taken possession of my entire soul, like<br> these sweet mornings of spring which I enjoy with my whole<br> heart. I am alone, and feel the charm of existence in this spot,<br> which was created for the bliss of souls like mine. I am so happy.<br><br> A wonderful serenity has taken possession of my entire soul, like<br> these sweet mornings of spring.A wonderful serenity has taken <br>possession of my entire soul, like these sweet mornings of spring <br>which I enjoy with my whole heart. I am alone, and <br><br>A wonderful serenity has taken possession of my entire soul, like <br>these sweet mornings.</p>
    </div>
    <div class="col stand">
        <img src="../../assets/img/fine.png">
    </div>
    <div class="w-100 mt-5"></div>
    <div class="col stand">
        <img src="../../assets/img/cat_img2.png">
    </div>
    <div class="col">
      <h3 class="all mt-5"> Our Approch</h3>
         <p class="long">A wonderful serenity has taken possession of my entire soul, like<br> these sweet mornings of spring which I enjoy with my whole<br> heart. I am alone, and feel the charm of existence in this spot,<br> which was created for the bliss of souls like mine. I am so happy.<br><br> A wonderful serenity has taken possession of my entire soul, like<br> these sweet mornings of spring.A wonderful serenity has taken <br>possession of my entire soul, like these sweet mornings of spring <br>which I enjoy with my whole heart. I am alone, and <br><br>A wonderful serenity has taken possession of my entire soul, like <br>these sweet mornings.</p>
    </div>
    <div class="w-100 mt-5"></div>
    <div class="col">
       <h3 class="all mt-5"> Our Process</h3>
         <p class="long">A wonderful serenity has taken possession of my entire soul, like<br> these sweet mornings of spring which I enjoy with my whole<br> heart. I am alone, and feel the charm of existence in this spot,<br> which was created for the bliss of souls like mine. I am so happy.<br><br> A wonderful serenity has taken possession of my entire soul, like<br> these sweet mornings of spring.A wonderful serenity has taken <br>possession of my entire soul, like these sweet mornings of spring <br>which I enjoy with my whole heart. I am alone, and <br><br>A wonderful serenity has taken possession of my entire soul, like <br>these sweet mornings.</p>
    </div>
    <div class="col stand">
      <img src="../../assets/img/bottom_img.png">
    </div>
  </div>
</div> 
</div>  
</template>

<script>



export default {
   
   data() {
    return {};
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/page6/reverse.vue